module.exports = "/_next/static/images/2996396d9a00edc7bd1be578bc9385fa-apple-pay-xs.png.webp";